import { useState, useEffect } from "react";
import { useSelector } from "react-redux";

const TypewriterText = ({ texts, typingSpeed = 100, deletingSpeed = 50, pause = 2000 }) => {
  const [text, setText] = useState("");
  const [index, setIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [charIndex, setCharIndex] = useState(0);

  useEffect(() => {
    const handleTyping = () => {
      const currentText = texts[index];
      if (!isDeleting) {
        if (charIndex < currentText.length) {
          setText((prev) => prev + currentText[charIndex]);
          setCharIndex((prev) => prev + 1);
        } else {
          setTimeout(() => setIsDeleting(true), pause);
        }
      } else {
        if (charIndex > 0) {
          setText(currentText.substring(0, charIndex - 1));
          setCharIndex((prev) => prev - 1);
        } else {
          setIsDeleting(false);
          setIndex((prev) => (prev + 1) % texts.length);
        }
      }
    };

    const timeout = setTimeout(handleTyping, isDeleting ? deletingSpeed : typingSpeed);
    return () => clearTimeout(timeout);
  }, [charIndex, isDeleting, index, texts, typingSpeed, deletingSpeed, pause]);

  return <span className="typewriter">{text}</span>;
};

const HomeTitle = () => {
  const italianText = [
    "Rivoluziona i tuoi sondaggi",
    "Esprimi la tua voce in modo innovativo",
    "Coinvolgi come mai prima d’ora"
  ];

  const englishText = [
    "Revolutionize your surveys",
    "Express your voice in innovative ways",
    "Engage like never before"
  ];

  const selectedLanguage = useSelector(state => state.languageInfo.selectedLanguage);
  const [texts, setTexts] = useState(selectedLanguage.code === "it" ? italianText : englishText);

  useEffect(() => {
    setTexts(selectedLanguage.code === "it" ? italianText : englishText);
  }, [selectedLanguage]);

  return (
    <h1 className="home-title mb-0 text-white display-5 notranslate" translate="no">
      <TypewriterText texts={texts} />
    </h1>
  );
};

export default HomeTitle;
